// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { icon } from '../../tokens/themeColors/icon';
export var SvgIcon = function(mode) {
    return {
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    fontSize: '20px'
                },
                fontSizeMedium: {
                    fontSize: '20px'
                },
                fontSizeSmall: {
                    fontSize: '16px'
                },
                fontSizeLarge: {
                    fontSize: '24px'
                },
                fontSizeInherit: {
                    fontSize: 'inherit'
                },
                colorPrimary: {
                    color: icon(mode).default
                },
                colorSecondary: {
                    color: icon(mode).heavy
                }
            }
        }
    };
};

//# sourceMappingURL=SvgIcon.js.map